export const DEFAULT_CAPTCHA_URL = 'captcha.ashx';
